import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Breadcrumb, Table, Container, Message} from 'semantic-ui-react';
import {Link} from "react-router-dom";
import CustomDivider from "../../components/extras/CustomDivider";
import Loading from "../../components/extras/Loading";
import PaymentData from "../../data/PaymentData";
import {FormattedNumber} from "react-intl";

class PaymentResponse extends Component {
    constructor(){
        super();
        this.state = {
            loading: true,
            data: {
                status: false
            }
        }
    }

    async componentDidMount(){
        let url_string = window.location.href;
        let url = new URL(url_string);
        let ref_payco = url.searchParams.get("ref_payco");
        PaymentData.getEpaycoData(ref_payco).then(data => {
            this.setState({loading:false, data});
        }).catch(() => {
            this.setState({loading:false});
        });
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Detalle Transacción - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section as={Link} to='/settings/suscription'>Mi Suscripción</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Detalle Transacción</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Container>
                    {this.state.loading ? <Loading/>:null}
                    {!this.state.loading && this.state.data.hasOwnProperty('success') ?<Table celled>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell collapsing><strong>Referencia</strong></Table.Cell>
                                <Table.Cell>{this.state.data.data.x_ref_payco}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell collapsing><strong>Fecha</strong></Table.Cell>
                                <Table.Cell>{this.state.data.data.x_transaction_date}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell collapsing><strong>Descripción</strong></Table.Cell>
                                <Table.Cell>{this.state.data.data.x_description}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell collapsing><strong>Estado Transacción</strong></Table.Cell>
                                <Table.Cell>{this.state.data.data.x_transaction_state}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell collapsing><strong>Motivo</strong></Table.Cell>
                                <Table.Cell>{this.state.data.data.x_response_reason_text}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell collapsing><strong>Banco</strong></Table.Cell>
                                <Table.Cell>{this.state.data.data.x_bank_name}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell collapsing><strong>Recibo</strong></Table.Cell>
                                <Table.Cell>{this.state.data.data.x_transaction_id}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell collapsing><strong>Total</strong></Table.Cell>
                                <Table.Cell>$
                                    <FormattedNumber
                                        value={this.state.data.data.x_amount}
                                        currency="USD"
                                        maximumFractionDigits={0}
                                        minimumFractionDigits={0}
                                    />
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>:null
                    }
                    {!this.state.loading && this.state.data.hasOwnProperty('success') && this.state.data.data.x_cod_transaction_state === 3 ? <Message
                        color='orange'
                        icon='warning sign'
                        header='Su pago se hará efectivo en nuestra plataforma en menos de 24 horas, muchas gracias!'
                    />:null
                    }
                    {!this.state.loading && this.state.data.hasOwnProperty('status') ? <Message
                        icon='bell'
                        header='Código de transacción no válido!'
                    />:null
                    }
                </Container>
            </div>
        );
    }
}

export default PaymentResponse;



// WEBPACK FOOTER //
// ./src/containers/settings/PaymentResponse.js